// IMPORTS
// =============================================================

const hasMainMenu = document.querySelector("#mainmenu");
const hasBreadcrumbBar = document.querySelector(".breadcrumb-bar");
const hasFlyoutSearch = document.querySelector("#search");
const hasClinicFinder = document.querySelector(".clinic-finder");
const hasModal = document.querySelector(".modal");
const hasNavTabs = document.querySelector(".nav-tabs");
const hasSwiper = document.querySelector(".swiper-container");
// const hasReadMoreBlock = document.querySelector(".readmore-block");
const hastReadMoreMarker = document.querySelector(".read-more-marker");
const hasACC = document.querySelector(".acc");
const hasLightbox = document.querySelector(".lightbox");
const hasCAC = document.querySelector(".page-clinics-and-centers");
const hasCCM = document.querySelectorAll("[data-ccm-loader-group]");

// Parallel imports
// =============================================================
const imports = [];

if (hasMainMenu) {
  imports.push(import("./modules/flyout.module.js").then((m) => m.init()));
}

if (hasBreadcrumbBar) {
  imports.push(import("./modules/breadcrumb.module.js").then((m) => m.init()));
}

if (hasFlyoutSearch) {
  imports.push(
    import("./modules/flyoutSearch.module.js").then((m) => m.init())
  );
}

if (hasClinicFinder) {
  imports.push(
    import("./modules/clinicFinder.module.js").then((m) => m.init())
  );
}

if (hasModal) {
  imports.push(import("./modules/modal.module.js").then((m) => m.init()));
}

if (hasNavTabs) {
  imports.push(import("./modules/tab.module.js").then((m) => m.init()));
}

if (hasSwiper) {
  imports.push(import("./modules/swiper.module.js").then((m) => m.init()));
}

// if (hasReadMoreBlock) {
//   imports.push(
//     import("./modules/readmoreBlock.module.js").then((m) => m.init())
//   );
// }

if (hastReadMoreMarker) {
  imports.push(
    import("./modules/readMoreMarker.module.js").then((m) => m.init())
  );
}

if (hasACC) {
  imports.push(import("./modules/acc.module.js").then((m) => m.init()));
}

if (hasLightbox) {
  imports.push(import("./modules/lightbox.module.js").then((m) => m.init()));
}

if (hasCAC) {
  imports.push(
    import("./modules/ceClinicsCenters.module.js").then((m) => m.init())
  );
}

if (hasCCM) {
  imports.push(import("./modules/ccm19.mjs").then((m) => m.init()));
}

// Execute all in parallel
// =============================================================
if (imports.length) Promise.all(imports).catch(console.error);
